import * as React from 'react';
import { debounce } from 'lodash';
import { AxiosResponse } from 'axios';
import Table from './Table';
import { getVehicles } from '../../Navigator/NavigatorService';
import { postRequest } from '../../../Services/HttpService';
import useAnalytics from '../../../hooks/useAnalytics';

const RESPONSE_OK = 'ok';

interface IComponentProps {
  intl: any;
  item: any;
  groupsToggle: any;
  loader: any;
  loadCustomerIds: (data: { groupId: string; customerIds: number[] }) => void;
  allGroupsString: string;
}

export default function Body(props: IComponentProps) {
  const [dragFrom, setDragFrom] = React.useState<any>(null);
  const [elementId, setElementId] = React.useState<any>(null);
  const [unassignedVehicleString, setUnassignedVehicleString] = React.useState<string>('');
  const [vehicleString, setVehicleString] = React.useState<string>('');
  const [vehicleInGroupsString, setVehicleInGroupsString] = React.useState<string>('');
  const [selectedUnassignedItems, setSelectedUnassignedItems] = React.useState<any>([]);
  const [selectedAssignedItems, setSelectedAssignedItems] = React.useState<any>([]);
  const [unassignedVehicles, setUnassignedVehicles] = React.useState<any>([]);
  const [assignedVehicles, setAssignedVehicles] = React.useState<any>([]);
  const { trackEvent } = useAnalytics();

  const getCustomerIds = (data) => {
    if (data) {
      return data.map((i) => i.customerId);
    }
    return [];
  };

  const handleCustomerIds = (ids: number[]) => {
    props.loadCustomerIds({ groupId: props.item.id, customerIds: ids });
  };

  const getUnassignedVehicles = async (id: any, string: string): Promise<void> => {
    if (!id) {
      return;
    }
    const filter = {
      filter: {
        vehicleName: string,
      },
    };
    setSelectedUnassignedItems([]);
    const assignToGroup = document.getElementById(`assignToGroup-${id}`);
    if (assignToGroup) {
      assignToGroup.classList.remove('active');
    }
    const response: AxiosResponse | false = await postRequest(
      `/v2/vehicle-group/${id}/unassigned-vehicles`,
      filter,
      { returnAxiosResponse: true, showToaster: false }
    );
    if (response && response.data && response.data.records) {
      setUnassignedVehicles(response.data.records);
    } else {
      setUnassignedVehicles([]);
    }
    props.loader(false);
  };

  const getGroupVehicles = async (id: any, string: string): Promise<void> => {
    if (!id) {
      return;
    }
    const filter = {
      filter: {
        vehicleName: string || vehicleInGroupsString,
      },
    };
    setSelectedAssignedItems([]);
    const assignToAll = document.getElementById(`assignToAll-${id}`);
    if (assignToAll) {
      assignToAll.classList.remove('active');
    }
    const response: AxiosResponse | false = await postRequest(
      `/v2/vehicle-group/${id}/vehicles`,
      filter,
      { showToaster: false, returnAxiosResponse: true }
    );
    if (response && response.data && response.data.records) {
      setAssignedVehicles(response.data.records);
      handleCustomerIds(getCustomerIds(response.data.records));
    } else {
      setAssignedVehicles([]);
      handleCustomerIds([]);
    }
    props.loader(false);
  };

  React.useEffect(() => {
    const id = Object.keys(props.groupsToggle)[0];

    if (id && String(props.item.id) === String(id)) {
      const assignToGroup = document.getElementById(`assignToGroup-${id}`);
      const assignToAll = document.getElementById(`assignToAll-${id}`);
      if (props.groupsToggle[id] !== undefined && props.groupsToggle[id] === true) {
        props.loader(true);
        getUnassignedVehicles(id, '');
        getGroupVehicles(id, '');

        setUnassignedVehicleString('');
        setVehicleString('');
        setSelectedUnassignedItems([]);
        setSelectedAssignedItems([]);

        if (assignToAll) {
          assignToAll.classList.remove('active');
        }
        if (assignToGroup) {
          assignToGroup.classList.remove('active');
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSortStart = (_key: any, event: any) => {
    event.preventDefault();
    let dragFromValue: null | string = null;
    if (
      event.target.classList.value === 'cmd-icon cmd-icon-arrow-right-2 d-none d-md-inline-block' ||
      event.target.classList.value ===
        'd-block d-lg-table-cell d-md-table-cell px-1 text-center col-2 col-md-auto order-1 left-side'
    ) {
      setDragFrom('clickFromAll');
    } else if (
      event.target.classList.value === 'cmd-icon cmd-icon-arrow-left-2 d-none d-md-inline-block' ||
      event.target.classList.value ===
        'd-block d-lg-table-cell d-md-table-cell px-1 text-center col-2 col-md-auto order-1 right-side'
    ) {
      setDragFrom('clickFromGroup');
    } else {
      if (
        event.target.parentElement.id === 'allCars' ||
        event.target.parentElement.parentElement.id === 'allCars' ||
        event.target.parentElement.parentElement.parentElement.id === 'allCars' ||
        event.target.parentElement.parentElement.parentElement.parentElement.id === 'allCars' ||
        event.target.parentElement.parentElement.parentElement.parentElement.parentElement.id ===
          'allCars'
      ) {
        dragFromValue = 'allCars';
      } else if (
        event.target.parentElement.id === 'thisGroup' ||
        event.target.parentElement.parentElement.id === 'thisGroup' ||
        event.target.parentElement.parentElement.parentElement.id === 'thisGroup' ||
        event.target.parentElement.parentElement.parentElement.parentElement.id === 'thisGroup' ||
        event.target.parentElement.parentElement.parentElement.parentElement.parentElement.id ===
          'thisGroup'
      ) {
        dragFromValue = 'thisGroup';
      }
      setDragFrom(dragFromValue);
    }

    let element = document.getElementById(event.target.id);
    if (!element) {
      element = document.getElementById(event.target.parentElement.id);
    }
    if (!element) {
      element = document.getElementById(event.target.parentElement.parentElement.id);
    }
    if (!element) {
      element = document.getElementById(event.target.parentElement.parentElement.parentElement.id);
    }

    if (element) {
      element.classList.add('activeItem');
      setElementId(element.id);
    }
  };

  const getNavigatorVehicleList = async (): Promise<void> => {
    await getVehicles();
  };

  const vehicleAdd = async (id: any, vehiclesIds: any): Promise<void> => {
    const assignToGroup: any = document.getElementById(`assignToGroup-${id}`);
    const assignToAll: any = document.getElementById(`assignToAll-${id}`);
    const items = unassignedVehicles.filter((i: any) => vehiclesIds.includes(String(i.vehicleId)));
    items.forEach((i: any) => {
      delete i.active;
      return i;
    });
    const newAllItems: any = [];
    if (vehiclesIds.length > 0) {
      assignToAll.classList.remove('active');
      assignToGroup.classList.remove('active');
      props.loader(true);
      const response: AxiosResponse | false = await postRequest(
        `/v2/vehicle-group/${id}/vehicle/add`,
        { vehicleId: vehiclesIds },
        { showToaster: false, returnAxiosResponse: true }
      );
      props.loader(false);
      if (response && response.data && response.data.status === RESPONSE_OK) {
        getNavigatorVehicleList();
        setSelectedUnassignedItems([]);
        setSelectedAssignedItems([]);

        JSON.parse(JSON.stringify(unassignedVehicles)).forEach((value: any) => {
          delete value.active;
          if (!vehiclesIds.includes(String(value.vehicleId))) {
            newAllItems.push(value);
          }
        });
        assignedVehicles.forEach((i: any) => {
          delete i.active;
          return i;
        });
        const newAssignedVehicles = assignedVehicles.concat(items);
        setUnassignedVehicles(newAllItems);
        setAssignedVehicles(newAssignedVehicles);
        handleCustomerIds(getCustomerIds(newAssignedVehicles));
      }
    }
  };

  const vehicleRemove = async (id: any, vehiclesIds: any): Promise<void> => {
    const assignToGroup: any = document.getElementById(`assignToGroup-${id}`);
    const assignToAll: any = document.getElementById(`assignToAll-${id}`);
    const items = assignedVehicles.filter((i: any) => vehiclesIds.includes(String(i.vehicleId)));
    items.forEach((i: any) => {
      delete i.active;
      return i;
    });
    const newGroupItems: any = [];
    if (vehiclesIds.length > 0) {
      assignToAll.classList.remove('active');
      assignToGroup.classList.remove('active');
      props.loader(true);
      const response: AxiosResponse | false = await postRequest(
        `/v2/vehicle-group/${id}/vehicle/remove`,
        { vehicleId: vehiclesIds },
        { showToaster: false, returnAxiosResponse: true }
      );
      props.loader(false);
      if (response && response.data && response.data.status === RESPONSE_OK) {
        getNavigatorVehicleList();
        setSelectedUnassignedItems([]);
        setSelectedAssignedItems([]);
        assignedVehicles.forEach((value: any) => {
          delete value.active;
          if (!vehiclesIds.includes(String(value.vehicleId))) {
            newGroupItems.push(value);
          }
        });
        unassignedVehicles.forEach((i: any) => {
          delete i.active;
          return i;
        });
        const newUnassignedVehicles = unassignedVehicles.concat(items);
        setAssignedVehicles(newGroupItems);
        handleCustomerIds(getCustomerIds(newGroupItems));
        setUnassignedVehicles(newUnassignedVehicles);
      }
    }
  };

  const onSortEnd = ({ oldIndex }: any, event: any) => {
    const id = Object.keys(props.groupsToggle)[0];
    const element: any = document.getElementById(elementId);
    element.classList.remove('activeItem');
    const assignToGroup: any = document.getElementById(`assignToGroup-${id}`);
    const assignToAll: any = document.getElementById(`assignToAll-${id}`);

    const vehicleId = elementId.split('-')[2];
    const newSelectedUnassignedItems: any = [];
    const newSelectedAssignedItems: any = [];
    if (element.classList.contains('active') === false) {
      if (dragFrom === 'allCars') {
        const thisItems = unassignedVehicles.map((i: any) => {
          if (String(i.vehicleId) === String(vehicleId)) {
            i.active = 'active';
          }
          return i;
        });
        selectedUnassignedItems.push(String(vehicleId));
        assignToGroup.classList.add('active');
        setSelectedUnassignedItems(selectedUnassignedItems);
        setUnassignedVehicles(thisItems);
      } else if (dragFrom === 'thisGroup') {
        const thisItems = assignedVehicles.map((i: any) => {
          if (String(i.vehicleId) === String(vehicleId)) {
            i.active = 'active';
          }
          return i;
        });
        selectedAssignedItems.push(String(vehicleId));
        assignToAll.classList.add('active');
        setSelectedAssignedItems(selectedAssignedItems);
        setAssignedVehicles(thisItems);
        handleCustomerIds(getCustomerIds(thisItems));
      }
    } else if (dragFrom === 'allCars') {
      JSON.parse(JSON.stringify(selectedUnassignedItems)).forEach((i: any) => {
        if (String(i) !== String(vehicleId)) {
          newSelectedUnassignedItems.push(i);
        }
      });
      if (newSelectedUnassignedItems.length === 0) {
        assignToGroup.classList.remove('active');
      }
      const thisItems = unassignedVehicles.map((i: any) => {
        if (String(i.vehicleId) === String(vehicleId)) {
          delete i.active;
        }
        return i;
      });
      setSelectedUnassignedItems(newSelectedUnassignedItems);
      setUnassignedVehicles(thisItems);
    } else if (dragFrom === 'thisGroup') {
      JSON.parse(JSON.stringify(selectedAssignedItems)).forEach((i: any) => {
        if (String(i) !== String(vehicleId)) {
          newSelectedAssignedItems.push(i);
        }
      });
      if (newSelectedAssignedItems.length === 0) {
        assignToAll.classList.remove('active');
      }
      const thisItems = assignedVehicles.map((i: any) => {
        if (String(i.vehicleId) === String(vehicleId)) {
          delete i.active;
        }
        return i;
      });
      setSelectedAssignedItems(newSelectedAssignedItems);
      setAssignedVehicles(thisItems);
      handleCustomerIds(getCustomerIds(thisItems));
    }

    const dropTo = event.target.id;
    const parentDropTo = event.target.parentElement.id;
    const parentParentDropTo = event.target.parentElement.parentElement.id;
    const parentParentParentDropTo = event.target.parentElement.parentElement.parentElement.id;

    if (
      (dragFrom === 'allCars' &&
        (dropTo === 'thisGroup' ||
          parentDropTo === 'thisGroup' ||
          parentParentDropTo === 'thisGroup' ||
          parentParentParentDropTo === 'thisGroup')) ||
      dragFrom === 'clickFromAll'
    ) {
      vehicleAdd(id, [String(oldIndex)]);
    }
    if (
      (dragFrom === 'thisGroup' &&
        (dropTo === 'allCars' ||
          parentDropTo === 'allCars' ||
          parentParentDropTo === 'allCars' ||
          parentParentParentDropTo === 'allCars')) ||
      dragFrom === 'clickFromGroup'
    ) {
      vehicleRemove(id, [String(oldIndex)]);
    }
  };

  const debouncedUnassignedVehicleSearch = debounce((value: string) => {
    setUnassignedVehicleString(value);
    getUnassignedVehicles(Object.keys(props.groupsToggle)[0], value);
  }, 300);

  const handleDebouncedSearchUnassignedVehicle = (event: any) => {
    debouncedUnassignedVehicleSearch(event.currentTarget.value);
  };

  const debouncedVehicleSearch = debounce((value: string) => {
    setVehicleString(value);
    getGroupVehicles(Object.keys(props.groupsToggle)[0], value);
  }, 300);

  const handleDebouncedSearchVehicle = (event: any) => {
    debouncedVehicleSearch(event.currentTarget.value);
  };

  const handleSearchVehicleInGroups = (event: any): void => {
    setVehicleInGroupsString(event.currentTarget.value);
    getGroupVehicles(Object.keys(props.groupsToggle)[0], vehicleInGroupsString);
  };

  const assignVehicles = (event: any): void => {
    event.preventDefault();
    trackEvent(['table cars groups', 'click', 'Assign vehicles']);
    const from = event.currentTarget.getAttribute('data-value');
    const id = Object.keys(props.groupsToggle)[0];
    const assignToGroup: any = document.getElementById(`assignToGroup-${id}`);
    const assignToAll: any = document.getElementById(`assignToAll-${id}`);
    if (from === 'fromAll') {
      vehicleAdd(id, selectedUnassignedItems);
      setSelectedUnassignedItems([]);
      assignToGroup.classList.remove('active');
    } else if (from === 'fromGroup') {
      vehicleRemove(id, selectedAssignedItems);
      setSelectedAssignedItems([]);
      assignToAll.classList.remove('active');
    }
  };

  const handleAllCarsCheckbox = (event: any): void => {
    const id = event.currentTarget.getAttribute('data-id');
    trackEvent(['table cars groups', 'change', 'Handle All Cars Checkbox']);
    const assignToGroup = document.getElementById(`assignToGroup-${id}`);
    if (selectedUnassignedItems.length === 0 && unassignedVehicles.length > 0) {
      const selectedVehicles: any = [];
      const unassignedVehiclesValues = unassignedVehicles;
      unassignedVehicles.forEach((i: any) => {
        i.active = 'active';
        selectedVehicles.push(String(i.vehicleId));
        return i;
      });

      setUnassignedVehicles(unassignedVehiclesValues);
      setSelectedUnassignedItems(selectedVehicles);

      if (assignToGroup) {
        assignToGroup.classList.add('active');
      }
    } else {
      const unassignedVehiclesValues = unassignedVehicles;
      unassignedVehiclesValues.forEach((i: any) => {
        delete i.active;
        return i;
      });

      setUnassignedVehicles(unassignedVehiclesValues);
      setSelectedUnassignedItems([]);

      if (assignToGroup) {
        assignToGroup.classList.remove('active');
      }
    }
  };

  const handleGroupCheckbox = (event: any): void => {
    const id = event.currentTarget.getAttribute('data-id');
    trackEvent(['table cars groups', 'change', 'Handle Group Checkbox']);
    const assignToAll = document.getElementById(`assignToAll-${id}`);
    if (selectedAssignedItems.length === 0 && assignedVehicles && assignedVehicles.length > 0) {
      const selectedVehicles: any = [];
      const assignedVehiclesValues = assignedVehicles;
      assignedVehiclesValues.forEach((i: any) => {
        i.active = 'active';
        selectedVehicles.push(String(i.vehicleId));
        return i;
      });

      setAssignedVehicles(assignedVehiclesValues);
      handleCustomerIds(getCustomerIds(assignedVehiclesValues));
      setSelectedAssignedItems(selectedVehicles);

      if (assignToAll) {
        assignToAll.classList.add('active');
      }
    } else {
      const assignedVehiclesValues = assignedVehicles;
      assignedVehiclesValues.forEach((i: any) => {
        delete i.active;
        return i;
      });

      setAssignedVehicles(assignedVehiclesValues);
      handleCustomerIds(getCustomerIds(assignedVehiclesValues));
      setSelectedAssignedItems([]);

      if (assignToAll) {
        assignToAll.classList.remove('active');
      }
    }
  };

  // if (!unassignedVehicles) {
  //   unassignedVehicles = [];
  // }
  // if (!assignedVehicles) {
  //   assignedVehicles = [];
  // }

  return (
    <div id="collapse-car-groups-list" key={`body-${props.item.id}`}>
      <div className="px-5 py-3 table-responsive">
        <Table
          item={props.item}
          groupItems={assignedVehicles}
          allItems={unassignedVehicles}
          onSortEnd={onSortEnd}
          onSortStart={onSortStart}
          intl={props.intl}
          handleAllCarsCheckbox={handleAllCarsCheckbox}
          selectedUnassignedItems={selectedUnassignedItems}
          unassignedVehicles={unassignedVehicles}
          handleSearchUnassignedVehicle={handleDebouncedSearchUnassignedVehicle}
          unassignedVehicleString={unassignedVehicleString}
          handleSearchVehicle={handleDebouncedSearchVehicle}
          handleGroupCheckbox={handleGroupCheckbox}
          selectedAssignedItems={selectedAssignedItems}
          assignedVehicles={assignedVehicles}
          vehicleString={vehicleString}
          allGroupsString={props.allGroupsString}
        >
          <div className="col-12 col-lg-auto col-lg-auto px-2 align-self-center justify-content-center text-center">
            <a
              onClick={assignVehicles}
              href="/"
              title=""
              data-value="fromAll"
              data-cy="cars-group-button-from-all"
              id={`assignToGroup-${props.item.id}`}
              className="e-transfer-icon my-3 mx-1 d-inline-block d-lg-block"
            >
              <i className="cmd-icon cmd-icon-direction-right d-none d-lg-inline-block" />
              <i className="cmd-icon cmd-icon-direction-down d-lg-none" />
            </a>
            <a
              onClick={assignVehicles}
              href="/"
              data-value="fromGroup"
              id={`assignToAll-${props.item.id}`}
              title=""
              data-cy="cars-group-button-from-group"
              className="e-transfer-icon my-3 mx-1 d-inline-block d-lg-block"
            >
              <i className="cmd-icon cmd-icon-direction-left d-none d-lg-inline-block" />
              <i className="cmd-icon cmd-icon-direction-up d-lg-none" />
            </a>
          </div>
        </Table>
      </div>
    </div>
  );
}
